import React from "react";
import styled from "styled-components";

function Title() {
  return (
    <TitleWrap>
      <div className="title">코소롱</div>
      <div className="subtitle">제주어 오디오북 생성기</div>
    </TitleWrap>
  );
}

export default Title;

const TitleWrap = styled.div`
  }
  .title {
    font-style: normal;
    font-weight: normal;
    font-size: 64px;
    letter-spacing: 0.06em;
    color: #000000;
  }
  .subtitle {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    padding-left: 63px;
    letter-spacing: 0.06em;
    color: #000000;
`;
